import { deviceInformation } from '../../../helpers/device';

export const FOCUS_DELAY = 400;

/**
 * Puts focus on specified element after a fixed delay. When you don't
 * want to focus on mobile set `focusMobile` to false.
 */
export default (elm, focusMobile = true) => {
	if ((focusMobile || !deviceInformation.isMobile) && elm) {
		setTimeout(() => elm.focus(), FOCUS_DELAY);
	}
};
